<template>
    <div class="layer" v-show="show">
        <div class="wrapper">
            <div class="box_org">
                <img src="//images.jinku.com/newjk/org/images/layer_colse_03.png" alt="" style="width: .24rem;height: .24rem;" class="close" @click="close">
                <img src="//images.jinku.com/newjk/org/images/layer_03.png" alt="" style="width: 2.34rem;height: 2.16rem;margin-top: .63rem;">
                <p style="color: #838383;font-size: .24rem;margin-bottom: .66rem;">请先完成能力测评</p>
                <p style="color: #004990;font-size: .26rem;" v-on:click="toCp">测评</p>
            </div>
        </div>
    </div>
</template>

<script>
    import http from "../../lib/http";
    export default{
        name:'layer',
        data(){
            return{
                show:false
            }
        },
        methods:{
            close(){
                this.show = false;
                this.toCp();
            },
            //检测是否完成评测
            checkCePing:function () {
                let that = this;
                http({
                    method: "post",
                    url: "/org/evaluation/check-ce-ping",
                    data: ""
                }).then(function(res){
                    if(res.code == 0 && res.data.is_test == 0){
                        that.show = true;
                    }
                }).catch(function(err){

                });
            },
            toCp:function () {
                this.$router.push('/ceping');
            }
        },
        created() {
            this.checkCePing();
        }

    }
</script>

<style>
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: rgb(0,0,0,.3);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
      }

      .box_org {
        width: 4.55rem;
        height: 4.4rem;
        background-color: #fff;
        text-align: center;
        border-radius: .1rem;
        position: relative;
      }
      .close{
          position: absolute;
          right: 7%;
          top: 5%;
      }
</style>



// WEBPACK FOOTER //
// src/components/tab-bar/layer.vue